import { Snackbar, Alert, Stack, styled, Typography } from '@mui/material';

import React from 'react';

import { ReactComponent as CloseIcon } from 'common/assets/images/close.svg';
import { ReactComponent as InfoIcon } from 'common/assets/images/info-icon.svg';
import {
	CONTROL_FILE_UPLOAD_SUCCESS_MAIN_LABEL,
	CONTROL_FILE_UPLOAD_SUCCESS_LABEL,
	MAXIMUM_RETRY_ALERT,
} from 'common/constants/AISimulationConstants';

import styles from './BulkUploadAlertMessage.module.scss';

interface IBulkUploadAlertMessageProps {
	onClose: () => void;
	uploadSuccessAlert: boolean;
	uploadRetryAlert: boolean;
}
const { whiteBackground, iconColor } = styles;
const StyledAlert = styled(Alert)({
	backgroundColor: whiteBackground,
	'& .MuiAlert-icon': {
		display: 'none',
	},
});

const BulkUploadAlertMessage = (props: IBulkUploadAlertMessageProps) => {
	const { uploadSuccessAlert, onClose, uploadRetryAlert } = props;
	return (
		<div>
			<Snackbar
				open={uploadSuccessAlert || uploadRetryAlert}
				autoHideDuration={5000}
				data-testid="on-close"
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				onClose={onClose}
			>
				<StyledAlert className={styles['custom-alert-container']}>
					<Stack direction="column">
						<Stack direction="row" justifyContent="space-between">
							<Stack direction="row" spacing={1}>
								{uploadSuccessAlert && (
									<InfoIcon
										className={styles['info-alert-icon']}
										fill={iconColor}
									/>
								)}
								<Typography
									className={
										uploadSuccessAlert
											? styles['custom-alert-container-main-label']
											: styles['custom-alert-container-main-error-label']
									}
								>
									{uploadSuccessAlert
										? CONTROL_FILE_UPLOAD_SUCCESS_MAIN_LABEL
										: MAXIMUM_RETRY_ALERT}
								</Typography>
							</Stack>
							<CloseIcon
								className={styles['close-alert-icon']}
								onClick={onClose}
							/>
						</Stack>
						<Stack pt={1}>
							<Typography
								pl={3}
								className={styles['custom-alert-container-label']}
							>
								{uploadSuccessAlert && CONTROL_FILE_UPLOAD_SUCCESS_LABEL}
							</Typography>
						</Stack>
					</Stack>
				</StyledAlert>
			</Snackbar>
		</div>
	);
};
export default BulkUploadAlertMessage;
